function fallbackEventLabel(eventType: string): string {
  return eventType
    .split(/[._]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function activityEventLabel(
  t: (key: string, options?: { defaultValue?: string }) => string,
  eventType: string,
): string {
  return t(`activity:events.${eventType}`, { defaultValue: fallbackEventLabel(eventType) });
}
